export type SortOrderType = 1 | -1;

export class FilterRangeType {
    static readonly GREATER_THAN = 1;
    static readonly LESS_THAN = -1;
}

export interface SearchParams {
    organizationId?: number | string;
    freeText?: string;
    filterParams?: FilterParams[];
    sortParams?: SortParams;
    statusFilter?: string[];
    page: number;
    pageSize: number;
}

export interface FilterParams {
    fieldName: string;
    value: string[];
    range: boolean;
    rangeType?: number;
}

export interface SortParams {
    sortField: string;
    sortOrder: SortOrderType;
}